import React, { useState } from 'react';
import { Form, Button, Container, Row, Col } from 'react-bootstrap';
import api from './AxiosConfig'; // Import the configured Axios instance

function SignUp() {
    const [formData, setFormData] = useState({
        email: '',
        password: ''
    });
    
    const [message,      setMessage]      = useState('');
    const [messageClass, setMessageClass] = useState('OK');
    
    const handleChange = (e) => {
        const { name, value } = e.target;
        setFormData({ ...formData, [name]: value });
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        try {
            const response = await api.post('/site/signup', formData);
            setMessage(response.data.message);  // Display success message from server
            setMessageClass('OK');
        } catch (error) {
            if (error.response) {
                setMessage(error.response.data.message);  // Display error message from server
                setMessageClass('Error');
            } else {
                setMessage('An error occurred while signing up');
                setMessageClass('Error');
            }
        }
    };
    
    return (
        <Container>
            <Row className="justify-content-md-center">
                <Col md="6">
                    <h2>Sign Up</h2>
                    <Form onSubmit={handleSubmit}>
                        <Form.Group controlId="formEmail">
                            <Form.Label>Email address</Form.Label>
                            <Form.Control
                                type="email"
                                name="email"
                                value={formData.email}
                                onChange={handleChange}
                                placeholder="Enter email"
                            />
                        </Form.Group>

                        <Form.Group controlId="formPassword">
                            <Form.Label>Password</Form.Label>
                            <Form.Control
                                type="password"
                                name="password"
                                value={formData.password}
                                onChange={handleChange}
                                placeholder="Password"
                            />
                        </Form.Group>

                        <Button variant="primary" type="submit">
                            Sign Up
                        </Button>
                    </Form>
                    <p className={messageClass}>{message}</p>
                </Col>
            </Row>
        </Container>
    );
}

export default SignUp;
